<template>
  <a-card class="login-form-card">
    <ValidationObserver ref="observer">
      <a-form
        :label-width="80"
        slot-scope="{ validate }"
        @submit.prevent="validate().then(handleSubmit)"
      >
        <h2 class="title">
          {{ labels.subtitle }}
          <b :style="{ display: 'block' }">{{ labels.appName }}</b>
        </h2>
        <Input
          ref="emailField"
          v-model.trim="form.email"
          rules="required"
          vid="email"
          :placeholder="labels.form.email.placeholder"
          size="large"
          :allowClear="true"
          :label="labels.form.email.label"
          :autoFocus="true"
          @input="onlyLowecaseValidEmail($event, 'email')"
          @keyup.enter.native="validate().then(handleSubmit)"
        />
        <Input
          ref="passwordField"
          v-model="form.password"
          type="password"
          rules="required"
          vid="subject"
          :placeholder="labels.form.password.placeholder"
          size="large"
          :allowClear="true"
          :label="labels.form.password.label"
          autocomplete="current-password"
          @keyup.enter.native="validate().then(handleSubmit)"
        />

        <RecaptchaCheckbox
          v-if="false"
          v-model="form.recaptchaToken"
          vid="recaptcha"
          :label="'recaptcha'"
          :ref="'recaptcha'"
        />

        <a-form-item style="text-align: right">
          <router-link
            :to="{ name: 'password-reset' }"
            class="forget-password-link"
          >
            {{ labels.form.forgotPassword }}
          </router-link>
        </a-form-item>
        <a-form-item style="text-align: right">
          <a-button
            type="default"
            html-type="submit"
            :loading="submitting"
            :disabled="submitting"
            size="large"
            class="btn-login"
            @click.prevent="validate().then(handleSubmit)"
          >
            <span>{{ labels.form.submit }}</span>
          </a-button>
        </a-form-item>
        <a-form-item style="text-align: center">
          <span class="label">{{ labels.form.newInApp(labels.appName) }}</span>
          <router-link :to="{ name: 'register' }" class="register-link">
            {{ labels.form.register }}
          </router-link>
        </a-form-item>
      </a-form>
    </ValidationObserver>
  </a-card>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import _ from "lodash";
import Input from "@/components/core/VeeValidateForm/Input";
import RecaptchaCheckbox from "@/components/core/VeeValidateForm/RecaptchaCheckbox";
import labels from "@/utils/labels";
import EventBus, { ListEvents } from "../event";
import { mapActions, mapState } from "vuex";

const initialState = {
  email: "",
  password: "",
  // recaptchaToken: null,
};
const cpInitialState = {
  password: "",
  password_confirmation: "",
};
export default {
  name: "LoginForm",
  components: {
    ValidationObserver,
    Input,
    RecaptchaCheckbox,
  },
  data() {
    return {
      form: _.cloneDeep(initialState),
      submitting: false,
      labels: {
        ...labels.loginForm,
        appName: labels.appName,
        unknownServerError: labels.unknownServerError,
      },
      cpForm: _.cloneDeep(cpInitialState),
      cpErrors: [],
    };
  },
  methods: {
    ...mapActions("clientAuth", ["handleLogin", "changeTemporaryPassword"]),
    async onlyLowecaseValidEmail(value = "", field) {
      this.form[field] = await value
        .replace(/[^a-zA-Z0-9_\-@.]/g, "")
        .replaceAll(" ", "")
        .toLowerCase()
        .trim();
    },
    async handleChangeTemporaryPassword(token) {
      try {
        // SHOW MODAL TO CHANGE PASSWORD WITH PASSWORD AND CONFIRM PASSWORD
        this.$confirm({
          title: this.labels.form.cpModal.changeTemporaryPassword,
          content: (h) =>
            // TWO INPUTS FOR NEW PASSWORD AND CONFIRM PASSWORD
            h(
              "div",
              {
                class: "change-password-form-content",
              },
              [
                h("p", this.labels.form.cpModal.changeTemporaryPasswordMessage),
                // show errors list if any
                ...(this.cpErrors.length
                  ? [
                      h("a-alert", {
                        props: {
                          type: "error",
                          message: this.cpErrors.map((err) =>
                            h("div", { domProps: { innerHTML: err } })
                          ),
                          showIcon: true,
                          closable: true,
                        },
                        style: {
                          marginBottom: "1rem",
                        },
                      }),
                    ]
                  : []),
                h(
                  "a-form-item",
                  {
                    props: {
                      labelCol: { span: 24 },
                      label: this.labels.form.cpModal.newPassword.label,
                    },
                  },
                  [
                    h("a-input-password", {
                      props: {
                        type: "password",
                        placeholder:
                          this.labels.form.cpModal.newPassword.placeholder,
                        modelValue: this.cpForm.password,
                        defaultValue: this.cpForm.password,
                        class: "input-text",
                      },
                      on: {
                        change: (event) => {
                          if (this.cpErrors.length) this.cpErrors = [];
                          this.cpForm.password = event.target.value || "";
                        },
                      },
                      style: {
                        width: "100%",
                      },
                    }),
                  ]
                ),
                h(
                  "a-form-item",
                  {
                    props: {
                      labelCol: { span: 24 },
                      label: this.labels.form.cpModal.newPassword.label,
                    },
                  },
                  [
                    h("a-input-password", {
                      props: {
                        type: "password",
                        placeholder:
                          this.labels.form.cpModal.newPassword.placeholder,
                        modelValue: this.cpForm.password_confirmation,
                        defaultValue: this.cpForm.password_confirmation,
                        class: "input-text",
                      },
                      on: {
                        change: (event) => {
                          if (this.cpErrors.length) this.cpErrors = [];
                          this.cpForm.password_confirmation =
                            event.target.value || "";
                        },
                      },
                      style: {
                        width: "100%",
                      },
                    }),
                  ]
                ),
              ]
            ),
          iconType: "warning",
          okText: this.labels.form.cpModal.change,
          cancelText: this.labels.form.cpModal.cancel,
          width: 600,
          maskClosable: false,
          closable: false,
          keyboard: false,
          onOk: async () => {
            this.cpErrors = [];
            if (!this.cpForm.password) {
              this.cpErrors.push(this.labels.form.cpModal.newPassword.required);
            } else if (this.cpForm.password.length < 6) {
              this.cpErrors.push(
                this.labels.form.cpModal.newPassword.minLength
              );
            }
            if (!this.cpForm.password_confirmation) {
              this.cpErrors.push(
                this.labels.form.cpModal.confirmPassword.required
              );
            } else if (
              this.cpForm.password !== this.cpForm.password_confirmation
            ) {
              this.cpErrors.push(
                this.labels.form.cpModal.confirmPassword.confirmed
              );
            }
            const isValid = this.cpErrors.length === 0;
            if (!isValid) {
              return Promise.reject();
            }

            let { firstname, lastname } = await this.changeTemporaryPassword({
              password: this.cpForm.password,
              password_confirmation: this.cpForm.password_confirmation,
              token,
            });
            this.$message.success(this.labels.form.cpModal.passwordChanged);
            this.cpForm = _.cloneDeep(cpInitialState);

            const redirectRoute = this.redirectRoute;
            const redirectAfterAll = this.redirectAfterAll;
            if (redirectAfterAll?.includes("/")) {
              this.$router.push({ path: redirectAfterAll });
            } else {
              this.$router.push({ name: redirectRoute || "home" });
              this.$store.state.redirectRoute = null;
            }
            this.$message.success(
              `${this.labels.form.success}, ${firstname || ""} ${
                lastname || ""
              }`
            );

            return Promise.resolve();
          },
        });
      } catch (error) {
        console.error(error);
      }
    },
    async handleSubmit() {
      try {
        // if (!!this.form.recaptchaToken === false) {
        //   this.$error({
        //     title: this.labels.error,
        //     content: this.labels.form.notRobot,
        //     centered: true,
        //   });
        //   return;
        // }
        this.submitting = true;

        const formData = new FormData();
        const data = _.cloneDeep(this.form);
        Object.keys(data).forEach((key) => {
          formData.append(key, data[key]);
        });

        let {
          firstname,
          lastname,
          cpnl = false,
          token = null,
        } = await this.handleLogin(formData);

        if (!cpnl) {
          const redirectRoute = this.redirectRoute;
          const redirectAfterAll = this.redirectAfterAll;
          if (redirectAfterAll?.includes("/")) {
            this.$router.push({ path: redirectAfterAll });
          } else {
            this.$router.push({ name: redirectRoute || "home" });
            this.$store.state.redirectRoute = null;
          }
          this.$message.success(
            `${this.labels.form.success}, ${firstname || ""} ${lastname || ""}`
          );
        } else {
          this.handleChangeTemporaryPassword(token);
        }
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message ||
            error?.response?.message ||
            error.message
        );
        if (error?.response?.status === 401) {
          this.$error({
            title: this.labels.form.error,
            content:
              error?.response?.data?.message ||
              error?.message ||
              this.labels.form.errorMessage,
            centered: true,
          });
        } else {
          this.$notification["error"]({
            message: `${this.labels.form.error} ${
              error?.response?.code || "N/A"
            }`,
            description: this.labels.unknownServerError,
          });
        }
        EventBus.$emit(ListEvents.reset_recaptcha);
      } finally {
        this.submitting = false;
      }
    },
  },
  computed: {
    ...mapState(["redirectRoute", "redirectAfterAll"]),
  },
};
</script>
<style lang="scss">
@import "~@/assets/scss/variable";
.login-form-card {
  background-color: var(--card-shop-bg);
  border-color: var(--card-shop-shadow);
  box-shadow: 0 0 2px var(--card-shop-shadow);
  padding: 3.125rem;
  border-radius: 8px;
  @media screen and (max-width: $screen-mobile) {
    padding: 2.125rem 1rem;
  }
  .title {
    font-family: "Exo 2", sans-serif;
    color: var(--text);
    font-weight: 400;
    margin: 0;
    line-height: 1.3;
    word-break: break-word;
    font-size: 2rem;
    margin-bottom: 1rem;
    text-align: center;
  }
  .ant-card-body {
    padding: 0;
  }
  .ant-form label {
    font-size: 0.875rem;
    color: var(--text);
    font-family: "Roboto", sans-serif;
  }
  .ant-input {
    background-color: var(--input-bg);
    height: 3.75rem;
    color: var(--text);
    &:active,
    &:focus,
    &:hover {
      border-color: var(--text-muted);
    }
  }
  .ant-input-affix-wrapper {
    .ant-input:not(:first-child) {
      padding-left: 2.8125rem;
    }
    .ant-input-prefix {
      color: var(--text);
      font-size: 1.375rem;
      font-family: "Roboto", sans-serif;
    }
    .ant-input-clear-icon,
    .ant-input-password-icon,
    .ant-input-textarea-clear-icon {
      color: var(--text);
    }
  }

  .has-error .ant-input-affix-wrapper .ant-input,
  .has-error .ant-input-affix-wrapper .ant-input:hover {
    background-color: var(--input-bg);
  }

  .btn-login {
    color: var(--btn-text-secondary) !important;
    background-color: var(--btn-bg-secondary);
    border-color: var(--btn-bc-secondary);
    height: 51px;
    padding: 0 1.75rem;
    width: 100% !important;
  }

  .label {
    color: var(--text);
    font-family: "Roboto", sans-serif;
    text-decoration: none;
    font-size: 1rem;
    font-weight: 400;
    margin-left: 5px;
  }
  .register-link {
    @extend .label;
    color: var(--link);
    &:hover {
      text-decoration: underline;
    }
  }
  .forget-password-link {
    @extend .label;
    color: var(--link);
    &:hover {
      text-decoration: underline;
    }
  }
}

input:-internal-autofill-selected {
  background-color: var(--input-bg) !important;
  border-color: var(--text-active) !important;
  color: var(--text-muted) !important;
}

// animation
@keyframes shadowGlow {
  0% {
    box-shadow: 0 0 15px rgba(55, 245, 249, 0.15);
  }
  25% {
    box-shadow: 0 0 15px rgba(55, 245, 249, 0.25);
  }
  50% {
    box-shadow: 0 0 15px rgba(55, 245, 249, 0.35);
  }
  50% {
    box-shadow: 0 0 15px rgba(55, 245, 249, 0.45);
  }
  100% {
    box-shadow: 0 0 15px rgba(55, 245, 249, 0.15);
  }
}
</style>
